import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { SimpleIcon } from './icon-utils';

export function FolderWithDocsIcon({
  className,
  fill,
  height,
  width,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      fill={fill ?? '#324A52'}
      height={height ?? 24}
      strokeWidth={1.5}
      viewBoxDimensions="0 0 24 24"
      width={width ?? 24}
    >
      <path
        d="M18.75 6.75v-1.5a1.5 1.5 0 0 0-1.5-1.5h-9v-1.5a1.5 1.5 0 0 0-1.5-1.5h-4.5a1.5 1.5 0 0 0-1.5 1.5v16.3"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M3.75 20.25v-12a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5v1.5"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M8.25 9.75h13.5s1.5 0 1.5 1.5v10.5s0 1.5-1.5 1.5H8.25s-1.5 0-1.5-1.5v-10.5s0-1.5 1.5-1.5"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M18.75 20.25v-3"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M17.25 17.25h3"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.75 14.25h10.5"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.75 17.25h4.5"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M9.75 20.25h4.5"
        fill="none"
        stroke="#000000"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SimpleIcon>
  );
}
